import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function addCustomer(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function customer(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function tagList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function addFollow(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function discard(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}